<template>
  <p class="clearfix mb-0">
    <!-- <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT  © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https://www.gelogs.co.th/"
        target="_blank"
      >Grand Emporium Logistics</b-link>
    </span> -->

    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT  © 
      <b-link
        class="ml-25"
        href="https://www.fukuyama-gl.com/"
        target="_blank"
      >FUKUYAMA Grand Logistics</b-link>
    </span> 

    <span class="float-md-right d-none d-md-block">FGL
      <feather-icon
        icon="HeartIcon"
        size="21"
        class="text-danger stroke-current"
      />
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
